import React, { useState } from "react";
import {
  TextField,
  Button,
  Snackbar,
  Alert,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import axios from "axios";
import { Typography } from "antd";
import { authenticationService } from "src/services";
import { multy_post } from 'src/services/httpClient.service';

// Declare AlertColor explicitly for the severity state
type AlertColor = 'error' | 'info' | 'success' | 'warning';

const ADDApp = (props) => {
  const APIURL = process.env.REACT_APP_BASE_API_URL
  const URL_PATH = authenticationService.getVendorFranchisePath();
  const {vendorId, franchiseId} = authenticationService.getVendorFranchiseIds();

  const [formData, setFormData] = useState({
    logoFile: null, // File object
    applicationName: "",
    packageName: "",
    appType: "1", // Default value
    apk: "",
    priority: "1", // Default value
    access: "none", // Default value
    version: "none", // Default value
    link: "none", // Default value
  });
  const [loading, setLoading] = useState(false); // Loading state

  const [snackbarOpen, setSnackbarOpen] = useState(false); // Snackbar open state
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState<AlertColor>("success"); // Snackbar severity (success or error)

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      logoFile: file,
    });
  };

  const handleAdd = async () => {
    if (!formData.logoFile || !formData.applicationName || !formData.packageName) {
      setSnackbarMessage("Please fill in all fields and upload a logo.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const formDataToSend = new FormData();
    
    // Create appData object with all fields
    const appData = {
      applicationName: formData.applicationName,
      packageName: formData.packageName,
      appType: formData.appType,
      apk: formData.apk,
      priority: formData.priority,
      access: formData.access,
      version: formData.version,
      link: formData.link,
      vendorId: vendorId,
    };
    
    // Append appData as JSON string
    formDataToSend.append("appData", new Blob([JSON.stringify(appData)], { type: "application/json" }));
    formDataToSend.append("logo", formData.logoFile);

    try {
      setLoading(true);

      await multy_post(`${APIURL}/api/ott-apps`, formDataToSend);
       
      props.fetchApps();
      setSnackbarMessage("App added successfully!");
      setSnackbarSeverity("success");
      setTimeout(() => {
        props.handleClose();
      }, 2000);
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error adding app:", error);
      setSnackbarMessage("Failed to add app. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const [open, setOpen] = useState(true);

  return (
    <>
      <Box >
        <Box>
          <Button variant="contained" component="label" style={{ marginTop: 15 }}>
            Upload Logo
            <input
              type="file"
              accept="image/jpeg, image/png"
              hidden
              onChange={handleFileChange}
            />
          </Button>
          {formData.logoFile && <p>Selected file: {formData.logoFile.name}</p>}
          
          <TextField
            margin="dense"
            label="Application Name"
            name="applicationName"
            value={formData.applicationName}
            onChange={handleInputChange}
            fullWidth
          />
          
          <TextField
            margin="dense"
            label="Package Name"
            name="packageName"
            value={formData.packageName}
            onChange={handleInputChange}
            fullWidth
          />
          
          {/* New fields */}
          <FormControl fullWidth margin="dense">
            <InputLabel>App Type</InputLabel>
            <Select
              name="appType"
              value={formData.appType}
              onChange={handleInputChange}
              label="App Type"
            >
              <MenuItem value="1">Type 1</MenuItem>
              <MenuItem value="2">Type 2</MenuItem>
              <MenuItem value="3">Type 3</MenuItem>
            </Select>
          </FormControl>
          
          <TextField
            margin="dense"
            label="APK"
            name="apk"
            value={formData.apk}
            onChange={handleInputChange}
            fullWidth
            placeholder="Enter APK URL or leave empty"
          />
          
          <FormControl fullWidth margin="dense">
            <InputLabel>Priority</InputLabel>
            <Select
              name="priority"
              value={formData.priority}
              onChange={handleInputChange}
              label="Priority"
            >
              <MenuItem value="1">1 (Highest)</MenuItem>
              <MenuItem value="2">2</MenuItem>
              <MenuItem value="3">3</MenuItem>
              <MenuItem value="4">4</MenuItem>
              <MenuItem value="5">5 (Lowest)</MenuItem>
            </Select>
          </FormControl>
          
          <FormControl fullWidth margin="dense">
            <InputLabel>Access</InputLabel>
            <Select
              name="access"
              value={formData.access}
              onChange={handleInputChange}
              label="Access"
            >
              <MenuItem value="none">None</MenuItem>
              <MenuItem value="public">Public</MenuItem>
              <MenuItem value="private">Private</MenuItem>
              <MenuItem value="restricted">Restricted</MenuItem>
            </Select>
          </FormControl>
          
          <TextField
            margin="dense"
            label="Version"
            name="version"
            value={formData.version}
            onChange={handleInputChange}
            fullWidth
            placeholder="Enter version (e.g., 1.0.0)"
          />
          
          <TextField
            margin="dense"
            label="Link"
            name="link"
            value={formData.link}
            onChange={handleInputChange}
            fullWidth
            placeholder="Enter URL link"
          />
        </Box>
        
        <Box sx={{margin:'20px',display:'flex',flexDirection:'row-reverse'}}>
          <Button onClick={props.handleClose} color="primary" disabled={loading}>
            Cancel
          </Button>
          <Button onClick={handleAdd} color="primary" disabled={loading}>
            {loading ? "Adding..." : "Add"}
          </Button>
        </Box>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity} 
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ADDApp;